var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-icon",
    transform: "translate(-1796 -18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 28,
    height: 28,
    rx: 14,
    transform: "translate(1796 18)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fi-rr-pencil",
    d: "M11.468.62A1.82,1.82,0,0,0,8.9.62L.735,8.782A2.493,2.493,0,0,0,0,10.556v1.03a.5.5,0,0,0,.5.5h1.03a2.492,2.492,0,0,0,1.774-.735l8.162-8.162a1.82,1.82,0,0,0,0-2.571ZM2.6,10.643a1.517,1.517,0,0,1-1.064.441H1v-.528a1.5,1.5,0,0,1,.441-1.064L7.639,3.3,8.793,4.451Zm8.162-8.162L9.5,3.739,8.346,2.588,9.6,1.329a.815.815,0,0,1,1.152,1.154Z",
    transform: "translate(1804 25.912)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.bce18f885d4f216a042cc72f7dbf814a.svg";
export { ForwardRef as ReactComponent };